// LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { translations } from "./Translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem("e8_language");
        return saved ? saved : "en";
    });

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem("e8_language", lang);
    };

    useEffect(() => {
        localStorage.setItem("e8_language", language);
    }, [language]);

    return (
        <LanguageContext.Provider
            value={{
                language,
                changeLanguage,
                t: translations[language] || translations.en
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);